import { render, staticRenderFns } from "./TeamIcon.vue?vue&type=template&id=2d5cfb7c"
import script from "./TeamIcon.vue?vue&type=script&lang=js"
export * from "./TeamIcon.vue?vue&type=script&lang=js"
import style0 from "./TeamIcon.vue?vue&type=style&index=0&id=2d5cfb7c&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports